import Vue from "vue";
import VueRouter from "vue-router";
import { parseJwt } from "@/assets/js/jwt"; // 引用你寫的 parseJwt 函式
import Cookies from "js-cookie"; // 確保導入 Cookies 模組
import HomePage from "@/components/HomePage.vue"; // 首頁組件
import LoginPage from "@/components/LoginPage.vue";
import RoomPage from "@/components/RoomPage.vue";
import NewsPage from "@/components/NewsPage.vue";
import FoodPage from "@/components/FoodPage.vue";
import OrderPage from "@/components/OrderPage.vue";
import ContactusPage from "@/components/ContactusPage.vue";
import RegisterPage from "@/components/RegisterPage.vue";
import customerDashboard from "@/components/customer-dashboard.vue";
import DawnwoodSuite from "@/components/DawnwoodSuite.vue";
import BookingPage from "@/components/BookingPage.vue";
import LuminousGroveSuite from "@/components/LuminousGroveSuite.vue";
import TranquilForestSuite from "@/components/TranquilForestSuite.vue";
import AdminDashboard from "@/components/background/AdminDashboard";
import BackGroundPage from "@/components/background/BackGroundPage.vue";
import OrderManagement from "@/components/background/OrderManagement.vue";
import UserManagement from "@/components/background/UserManagement.vue";
import RoomManagement from "@/components/background/RoomManagement.vue";
import SpringManagement from "@/components/background/SpringManagement.vue";
import DiscountManagement from "@/components/background/DiscountManagement.vue";
import PostManagement from "@/components/background/PostManagement.vue";
import EmployeeManagement from "@/components/background/EmployeeManagement.vue";
import SpaPage from "@/components/SpaPage.vue";
import SpaJingTangGe from "@/components/SpaJingTangGe.vue";
import SpaQuanYunJu from "@/components/SpaQuanYunJu.vue";
import SpaTangZhiYuan from "@/components/SpaTangZhiYuan.vue";
import ForgotPage from "@/components/ForgotPage.vue";
import LeisureFacilities from "@/components/LeisureFacilities.vue";
import ResetPage from "@/components/ResetPage.vue";
import RoomDetail from "@/components/RoomDetail.vue";
import ContactusManagement from "@/components/background/ContactusManagement.vue";
import Swal from "sweetalert2";
import LineCallbackPage from "@/components/LineCallback.vue";
import TravelPage from "@/components/TravelPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage, // 登入頁面組件
    meta: {
      hideFooter: true,
    },
  },

  {
    path: "/register",
    name: "Register",
    component: RegisterPage,
  },

  {
    path: "/room",
    name: "Room",
    component: RoomPage, // 確保這裡正確引入 RoomPage 組件
  },
  {
    path: "/travel",
    name: "Travel",
    component: TravelPage, // 確保這裡正確引入 RoomPage 組件
  },
  {
    path: "/roomdetail",
    name: "RoomDetail",
    component: RoomDetail, // 確保這裡正確引入 RoomPage 組件
  },

  {
    path: "/news",
    name: "News",
    component: NewsPage, // 確保這裡正確引入 AboutPage 組件
  },
  {
    path: "/food",
    name: "Food",
    component: FoodPage, // 確保這裡正確引入 AboutPage 組件
    meta: { requiresAuth: false }, // 確保此路徑不需要登入
  },
  {
    path: "/contactus",
    name: "Contactus",
    component: ContactusPage, // 確保這裡正確引入 AboutPage 組件
    meta: { hideFooter: true },
  },
  {
    path: "/order",
    name: "Order",
    component: OrderPage,
    meta: { hideNavbar: true, hideFooter: true, requiresAuth: true }, // 需要登入且只有老闆和主管可以訪問, roles: [4 ]
  },
  {
    path: "/customer-dashboard",
    name: "customer-dashboard",
    component: customerDashboard,
    meta: {
      hideFooter: true, // 隱藏頁尾
    },
  },

  {
    path: "/dawnwood-suite",
    name: "DawnwoodSuite",
    component: DawnwoodSuite,
  },

  {
    path: "/luminous-grove-suite",
    name: "LuminousGroveSuite",
    component: LuminousGroveSuite,
  },

  {
    path: "/tranquil-forest-suite",
    name: "TranquilForestSuite",
    component: TranquilForestSuite,
  },
  {
    path: "/booking",
    name: "Booking",
    component: BookingPage,
    meta: { requiresAuth: true }, // 需要登入才能訪問
  },
  {
    path: "/spa",
    name: "SpaPage",
    component: SpaPage,
  },
  {
    path: "/spajing-tang-ge",
    name: "SpaJingTangGe",
    component: SpaJingTangGe,
  },
  {
    path: "/spaquan-yun-ju",
    name: "SpaQuanYunJu",
    component: SpaQuanYunJu,
  },
  {
    path: "/spatang-zhi-yuan",
    name: "SpaTangZhiYuan",
    component: SpaTangZhiYuan,
  },
  {
    path: "/forgot",
    name: "ForgotPage",
    component: ForgotPage,
  },
  {
    path: "/reset",
    name: "ResetPage",
    component: ResetPage,
    meta: { requiresAuth: false }, // 確保此路徑不需要登入
  },
  {
    path: "/line-callback",
    name: "LineCallback",
    component: LineCallbackPage,
    meta: {
      hideNavbar: true,
      hideFooter: true,
      requiresAuth: false, // 不需要預先登入，因為這就是登入過程
    },
  },
  {
    path: "/leisure-facilities",
    name: "LeisureFacilities",
    component: LeisureFacilities,
  },

  {
    path: "/admin",
    component: BackGroundPage,
    meta: {
      hideNavbar: true, // 隱藏導航列
      hideFooter: true, // 隱藏頁尾
      requiresAuth: true, // 需要登入
    },
    redirect: "/admin/dashboard", // 自動重定向到儀錶板
    children: [
      {
        path: "dashboard", // 這裡是相對於 /admin 的子路徑
        name: "Dashboard",
        component: AdminDashboard, // 儀錶板的組件
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "orders", // 這裡是相對於 /admin 的子路徑
        name: "OrderManegement",
        component: OrderManagement, // 儀錶板的組件
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "users", // 相對於 /admin 的子路徑
        name: "UserManagement",
        component: UserManagement,
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "contactus", // 相對於 /admin 的子路徑
        name: "ContactusManagement",
        component: ContactusManagement,
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "rooms", // 相對於 /admin 的子路徑
        name: "RoomManagement",
        component: RoomManagement,
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "springs", // 相對於 /admin 的子路徑
        name: "SpringManagement",
        component: SpringManagement,
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "discounts", // 相對於 /admin 的子路徑
        name: "DiscountManagement",
        component: DiscountManagement,
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "posts", // 相對於 /admin 的子路徑
        name: "PostManagement",
        component: PostManagement,
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
      {
        path: "employees", // 相對於 /admin 的子路徑
        name: "EmployeeManagement",
        component: EmployeeManagement,
        meta: {
          hideNavbar: true, // 隱藏導航列
          hideFooter: true, // 隱藏頁尾
        },
      },
    ],
  },
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    meta: { requiresAuth: true }, // 需要登入
  },
];

const router = new VueRouter({
  mode: "history", // 啟用 HTML5 History 模式
  routes,
  // 滾動行為控制
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 如果有儲存的滾動位置，返回該位置
    } else {
      return { x: 0, y: 0 }; // 頁面跳轉後滾動到頂部
    }
  },
});

// 全域導航守衛
router.beforeEach((to, from, next) => {
  const token = Cookies.get("token"); // Token 驗證區域
  const payload = token ? parseJwt(token) : null;
  const role = payload?.role ? parseInt(payload.role, 10) : null;

  // ✅ 1. 永遠放行 login / reset
  if (
    to.path === "/login" ||
    to.path === "/register" ||
    to.path.startsWith("/reset")
  ) {
    next();
    return;
  }

  // ✅ 2. 需要登入但沒 token
  if (to.matched.some((r) => r.meta.requiresAuth)) {
    if (!token || !payload) {
      Cookies.remove("token");

      // ⚠️ 只顯示，不等結果
      Swal.fire({
        icon: "warning",
        title: "尚未登入",
        text: "請先登入以繼續使用此功能",
        confirmButtonText: "確定",
      });

      next("/login"); // ✅ 同步 next
      return;
    }
  }

  // ✅ 3. 一般使用者禁止 admin
  if (role === 0 && to.path.startsWith("/admin")) {
    Swal.fire({
      icon: "error",
      title: "無權限",
      text: "您沒有權限訪問後台",
      confirmButtonText: "確定",
    });

    next("/"); // ✅ 同步
    return;
  }

  // ✅ 4. 已登入者禁止回 login
  if ((to.path === "/login" || to.path === "/register") && token) {
    next("/");
    return;
  }

  // ✅ 5. 預設放行
  next();
});

export default router;
